module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/planners-tile-d17bd9f1e3d0dcf7920cc1abefba18f7.jpg";